import { render } from "./RecommendationCard.vue?vue&type=template&id=132d8f9b"
import script from "./RecommendationCard.vue?vue&type=script&lang=js"
export * from "./RecommendationCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__